var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{attrs:{"color":_vm.state.color,"text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.state.icon)+" ")]),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('labels.synchronisation-state.status'))+" "),_c('b',[_vm._v(_vm._s(_vm.$t(_vm.state.label)))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }